<script>
import ReportSearchBlock from '../ReportSearchBlock';
import { mapActions, mapGetters } from 'vuex';
import debounce from 'lodash/debounce';

export default {
  name: 'ReportOptionList',
  mixins: [ReportSearchBlock],
  data() {
    return {
      placeholder: this.schema.title,
      loading: false,
    };
  },
  computed: {
    ...mapGetters('reports', ['byId']),
    customOptions() {
      if (!this.reportKey) return [];
      return this.byId(this.reportKey);
    },
    schemaOptions() {
      return this.schema?.options;
    },
    reportKey() {
      if (Array.isArray(this.schemaOptions)) return '';
      return this.schemaOptions;
    },
    getOptions() {
      if (this.reportKey) {
        return (this.customOptions?.data || []).map(({ text, value }) => {
          return {
            label: text,
            value,
          };
        });
      }

      return (this.schema?.options || []).map((option) => {
        return typeof option === 'object'
          ? option
          : {
              label: option,
              value: option,
            };
      });
    },
    formattedValue() {
      const multiple = this.schema?.multiple;
      let value = this.value || this.schema.default;

      if (!multiple) {
        return value;
      }

      value = Array.isArray(value) ? value : [value];
      return value.filter((v) => v);
    },
  },
  watch: {
    reportKey: {
      immediate: true,
      handler(val) {
        if (!val) return;
        this.loadOptions();
      },
    },
  },
  methods: {
    ...mapActions('reports', ['loadOne']),

    loadOptions: debounce(function (search) {
      const _search = search || this.value;
      if (!_search) return;

      let params = this.schema?.params || {};
      params.data = 1;
      params.search = _search;

      this.loading = true;
      this.loadOne({
        path: this.reportPath(),
        params,
      }).finally(() => {
        this.loading = false;
      });
    }, 300),

    updateSearch(search) {
      this.loadOptions(search);
    },

    reportPath() {
      const sharePid = this.schema?.pid;

      let path = this.reportKey;
      if (sharePid) {
        path = `shared/${sharePid}/${path}`;
      }
      return path;
    },
  },
};
</script>
